export default {"src":"/_next/static/media/positionOpposition.a99a7e91.svg","height":400,"width":401,"blurWidth":0,"blurHeight":0};